export default __webpack_public_path__ + "static/media/607.14850e1e.jpg";